export default function Lights() {
  const amp1 = 1.6,
    amp2 = 1.35,
    amp3 = 1.65;

  return (
    <>
      <pointLight
        position={[-4.3 * amp1, 5.0 * amp1, 4.2 * amp1]}
        intensity={0.7}
        color={"#ffe500"}
      />
      <pointLight
        position={[-2.85 * amp2, 3.2 * amp2, -2.9 * amp2]}
        intensity={0.7}
        color={"#ffe500"}
      />
      <pointLight
        position={[-3.0, 5.0, 0.0]}
        intensity={1.0}
        color={"#ffe500"}
      />
      <pointLight
        position={[3.2 * amp2, -4.2 * amp2, -4.12 * amp2]}
        intensity={0.7}
        color={"#00f6ff"}
      />
      <pointLight
        position={[1.9 * amp3, -6.0 * amp3, 2.8 * amp3]}
        intensity={0.7}
        color={"#00f6ff"}
      />
      <pointLight
        position={[3.0, -5.0, 0.0]}
        intensity={0.7}
        color={"#00f6ff"}
      />
      <ambientLight intensity={0.3} />
    </>
  );
}
